import DataOriginModel from '../models/DataOriginModel';
import BaseStore from './BaseStore';

class DataOriginStore extends BaseStore {
  stationStore;
  dataOriginParameterStore;

  constructor(transportLayer, stationStore, dataOriginParameterStore) {
    super(DataOriginModel, transportLayer);
    this.stationStore = stationStore;
    this.dataOriginParameterStore = dataOriginParameterStore;
  }
}

export default DataOriginStore;



// WEBPACK FOOTER //
// ./src/stores/DataOriginStore.js